import type { DragEvent } from 'react';

import { DesignerInfoContextMenuItems } from '@/components/designer-info-context-menu-items';
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuTrigger,
} from '@/components/ui/context-menu';

type BlockerProps = {
  on_blocker_drag_event: (drag_event: DragEvent<HTMLDivElement>) => void;
  on_refresh_menu_select: () => void;
};

export function Blocker({
  on_blocker_drag_event,
  on_refresh_menu_select,
}: BlockerProps) {
  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>
        <div
          aria-hidden="true"
          className="fixed inset-0 z-40 cursor-default select-none opacity-0"
          draggable={false}
          onDragOver={on_blocker_drag_event}
          onDragStart={on_blocker_drag_event}
          onDrop={on_blocker_drag_event}
        >
          Blocker
        </div>
      </ContextMenuTrigger>
      <ContextMenuContent>
        <ContextMenuItem onSelect={on_refresh_menu_select}>
          刷新
        </ContextMenuItem>
        <DesignerInfoContextMenuItems />
      </ContextMenuContent>
    </ContextMenu>
  );
}
